<template>
  <component class="d-flex align-items-center sidebar-link"
    :is="tag"
    v-bind="$attrs"
    tag="li"
    @click.native="hideSidebar"
  >
    <a class="nav-link d-flex align-items-center" v-bind="$attrs">
      <slot>
        <i v-if="link.icon" :class="link.icon"></i>
        <p>{{link.name}}</p>
      </slot>
    </a>

    <span class="line"></span>
  </component>
</template>
<script>
  export default {
    inheritAttrs: false,
    inject: {
      autoClose: {
        default: true
      }
    },
    props: {
      link: {
        type: [String, Object],
        default: () => {
          return {
            name: '',
            path: '',
            icon: ''
          }
        }
      },
      tag: {
        type: String,
        default: 'router-link'
      }
    },
    methods: {
      hideSidebar () {
        if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }
</script>

<style scoped>

.nav-link {
  padding: 5px 0 !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  margin-left: 6px !important;
  white-space: nowrap;
}

.sidebar-link {
  height: 37px;
  position: relative;
}

.line {
  background-color: #33C9D2;
  position: absolute;
  height: 100%;
  width: 3px;
  left: 0;
  top: 0;
  transform: translateX(-200%);
  transition-duration: .15s;
}

.active .line {
  transform: translateX(0);
}

</style>

<style>

.sidebar-link .nav-link p {
  text-transform: none !important;
  font-size: 0.75rem !important;
  line-height: 1.25rem !important;
}

</style>
